import { AxiosError } from 'axios'
import { ErrorResponseSchema } from '@reward-platform/shared-api/exceptions'
import { GenericClientError } from './GenericClientError'
import { ERROR_CODES } from './clientErrors'

export class ApiRouteRequestError extends GenericClientError {
  public kind?: string

  constructor(axiosError: AxiosError) {
    super(ERROR_CODES.API_ROUTE, axiosError)

    if (axiosError.response) {
      this.httpStatus = axiosError.response.status
    }
    if (axiosError.code) {
      this.code = axiosError.code
    }
    if (
      axiosError.response?.data &&
      typeof axiosError.response.data === 'object' &&
      'kind' in axiosError.response.data
    ) {
      this.kind = axiosError.response.data.kind as string
    }
    this.originalError = axiosError

    const parsedResponse = ErrorResponseSchema.safeParse(axiosError.response?.data)
    if (parsedResponse.success) {
      const { developerMessage, businessMessage, code, validationErrors, unrecoverable } =
        parsedResponse.data
      if (developerMessage) {
        this.developerMessage = developerMessage
      }
      if (businessMessage) {
        this.businessMessage = businessMessage
      }
      if (code) {
        this.code = code
      }
      this.validationErrors = validationErrors
      this.fatal = unrecoverable ?? false
    }
  }
}
